import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExternalInitializationComponent } from './external-initialization/external-initialization/external-initialization.component';
import { AuthGuardService } from './guards/auth-guard.service';
import { TokenGuardService } from './guards/token-guard.service';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { AuthWrapperComponent } from './modules/auth/auth-wrapper/auth-wrapper.component';

import { WorkInProgressComponent } from './shared/components/work-in-progress/work-in-progress.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'externalInitialization',
    component: ExternalInitializationComponent
  },
  {
    path: 'externalInitialization/:id',
    component: ExternalInitializationComponent
  },
  {
    path: 'login',
    canActivate: [TokenGuardService],
    component: AuthWrapperComponent,
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'home',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
      },
      {
        path: 'settings',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule),
      },
      {
        path: 'users',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule),
      },
      {
        path: 'inventory',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/inventory/inventory.module').then(m => m.InventoryModule),
      },
      {
        path: 'plants',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/plants/plants.module').then(m => m.PlantsModule),
      },
      {
        path: 'tracker',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/tracker/tracker.module').then(m => m.TrackerModule),
      },
      {
        path: 'vehicles',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/vehicles/vehicles.module').then(m => m.VehiclesModule),
      },
      {
        path: 'events',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/events/events.module').then(m => m.EventsModule),
      },
      {
        path: 'wiki',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/knowledge-base/knowledge-base.module').then(m => m.KnowledgeBaseModule),
      },
      {
        path: 'analytics',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/analytics/analytics.module').then(m => m.AnalyticsModule),
      },
      {
        path: 'devices',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/devices/devices.module').then(m => m.DevicesModule),
      },
      {
        path: 'assets',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/assets/assets.module').then(m => m.AssetsModule),
      },
      {
        path: 'people',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/people/people.module').then(m => m.PeopleModule),
      },
      {
        path: 'developer',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/developer/developer.module').then(m => m.DeveloperModule),
      },
      {
        path: 'dtc',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/dtc/dtc.module').then(m => m.DtcModule),
      },
      {
        path: 'case',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/case/case.module').then(m => m.CaseModule),
      },
      {
        path: 'rules',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/rules/rules.module').then(m => m.RulesModule),
      },
      {
        path: 'protus',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/protus/protus.module').then(m => m.ProtusModule),
      },
      {
        path: 'log',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/audit-history/audit-history.module').then(m => m.AuditHistoryModule),
      }
    ]
  },
  {
    path: 'wip',
    component: WorkInProgressComponent
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
